import { PropTypes } from 'base/react-libs';
import { Button } from '@evertrue/et-components';
import { useState } from 'react';
import { getCounterIconComponent } from './helpers/icon-fetch';

const JourneyActionTypeFilterButton = ({
  name,
  count,
  onClick = () => {},
  setActiveFilter,
  actionTypes,
  activeFilter,
}) => {
  const getFilterArray = () => {
    if (name === 'Other') return actionTypes;
    else {
      return [name.substring(0, name.length - 1).toUpperCase()];
    }
  };

  let checkSubset = (parentArray, subsetArray) => {
    return subsetArray.every((el) => {
      return parentArray.includes(el);
    });
  };
  const [toggle, setToggle] = useState(checkSubset(activeFilter, getFilterArray()));

  const handleClick = () => {
    if (!toggle) {
      //add filter to activeFilter
      setActiveFilter([...activeFilter, ...getFilterArray()]);
    } else {
      //return filter from active Filter
      setActiveFilter(activeFilter.filter((el) => !getFilterArray().includes(el)));
    }
    setToggle(!toggle);
  };

  return (
    <div className="task-counter-icon">
      <Button
        type="simple"
        className={toggle ? 'task-counter-icon-toggle' : 'task-counter-icon-toggle-false'}
        onClick={handleClick}
      >
        {getCounterIconComponent(name)}
        <div className={toggle ? 'task-count-icon-toggle' : 'task-count-icon-toggle-false'}>{count}</div>
      </Button>
    </div>
  );
};

JourneyActionTypeFilterButton.propTypes = {
  name: PropTypes.string,
  count: PropTypes.number,
  onClick: PropTypes.func,
  setActiveFilter: PropTypes.func,
  actionTypes: PropTypes.array,
  activeFilter: PropTypes.array,
};

export default JourneyActionTypeFilterButton;
